function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const ConsultantsWithAccessForm = _ref => {
  let {
    consultantsAndAdmins,
    claimGroup,
    handleConsultantToClaimGroupCreate,
    size = 'sm',
    isUnderReview
  } = _ref;
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const {
    t
  } = useTranslation();
  const handleChange = e => {
    const consultant = consultantsAndAdmins.find(consultant => consultant.id === +e.target.value);
    setSelectedConsultant(consultant);
  };
  const submit = () => {
    handleConsultantToClaimGroupCreate(_objectSpread(_objectSpread({}, selectedConsultant), {}, {
      role: selectedRole
    }));
    setSelectedRole('');
    setSelectedConsultant('');
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: size === 'lg' ? 2 : 1
  }, t('consultant'), "*"), /*#__PURE__*/React.createElement(Col, {
    md: size === 'lg' ? 4 : 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    size: "md",
    name: "consultant_id",
    onChange: e => handleChange(e),
    type: "text",
    placeholder: "Small text",
    value: (selectedConsultant === null || selectedConsultant === void 0 ? void 0 : selectedConsultant.id) || '',
    disabled: isUnderReview
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), consultantsAndAdmins.sort((a, b) => a.name.localeCompare(b.name)).map(c => {
    return /*#__PURE__*/React.createElement("option", {
      key: c.id,
      value: c.id
    }, c.name);
  }))), /*#__PURE__*/React.createElement(Col, {
    md: size === 'lg' ? 4 : 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    size: "md",
    name: "role",
    onChange: e => setSelectedRole(e.target.value),
    type: "text",
    placeholder: "Small text",
    value: selectedRole,
    disabled: isUnderReview
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), /*#__PURE__*/React.createElement("option", {
    value: 'claim_group_access_lead_consultant'
  }, t('lead_consultant')), /*#__PURE__*/React.createElement("option", {
    value: 'claim_group_access_supporting_consultant'
  }, t('supporting_consultant')))), /*#__PURE__*/React.createElement(Col, {
    md: size === 'lg' ? 2 : 1
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !selectedConsultant || !selectedRole || isUnderReview,
    variant: "link",
    onClick: submit
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add')))));
};
export default ConsultantsWithAccessForm;